import { PnlReportSummary } from '../starGridTypes';
import { PnlDeckGroup } from '../reportSelectors.types';

/**
 * Whether a report belongs in a picker: the nav's Reports section, the home list, deck groups.
 *
 * A DEACTIVATED report is excluded — hiding it from the pickers is the entire point of deactivating
 * it, and it was still being listed in the nav. `is_active` is optional in the type, so only an
 * explicit `false` hides a report; a row from an older response with the field absent stays visible.
 */
// Visibility is the report's own `is_active` flag -- never its name. A hardcoded list of legacy test
// names hid any real report that happened to share one (a user's own "WW Report").
export const isReportVisible = (report: Pick<PnlReportSummary, 'report_name'> & Partial<Pick<PnlReportSummary, 'is_active'>>): boolean =>
  report.is_active !== false;

export const visibleReportDecks = (groups: readonly PnlDeckGroup[]): PnlDeckGroup[] =>
  groups.map((group) => ({ ...group, reports: group.reports.filter(isReportVisible) }));
